import React, { useState } from 'react'
import { Paper, Button, CircularProgress } from '@material-ui/core'
import { Helmet } from 'react-helmet'

import useGetRunTotalsQuery from './graphql/useGetRunTotalsQuery'
import SubmitForm from './submitForm'

export default () => {
  const getRunTotals = useGetRunTotalsQuery()
  const [submitDialogOpen, setSubmitDialogOpen] = useState(false)

  const { data, loading, error, refetch } = getRunTotals()

  if (error) {
    setTimeout(() => window.location.reload(), 3000)
  }

  const onCloseDialog = () => {
    setSubmitDialogOpen(false)
    refetch()
  }

  return (
    <div
      style={{
        width: '100vw',
        height: '100vh',
        display: 'flex',
        flexFlow: 'column nowrap',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundImage: "url('./sparc-counter.jpg')",
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
      }}
    >
      <Helmet>
        <title>SPARC Tracker</title>
        <meta
          name="description"
          content="A custom tracker for the Stevens Point Area Run Club to track miles ran!"
        />
      </Helmet>
      <Paper
        elevation={10}
        style={{
          display: 'flex',
          flexFlow: 'column nowrap',
          fontSize: '30px',
          justifyContent: 'center',
          alignItems: 'center',
          padding: 20,
          textAlign: 'center',
          margin: '0px 20px',
        }}
      >
        {loading ? (
          <CircularProgress color="primary" />
        ) : error ? (
          <React.Fragment>
            <span>There has been some confusion.</span>
            <span>Will try to "run" this for you again in 3 seconds...</span>
          </React.Fragment>
        ) : (
          <React.Fragment>
            <span>SPARC members have ran a total of</span>
            <span style={{ fontWeight: 'bold', fontSize: '40px' }}>
              {data.totalMiles.toFixed(2)}
            </span>
            <span>miles!</span>
            <Button
              onClick={() => setSubmitDialogOpen(true)}
              variant={'contained'}
              color="primary"
              style={{ marginTop: 15 }}
            >
              Add My Miles!
            </Button>
          </React.Fragment>
        )}
      </Paper>
      <SubmitForm onClose={onCloseDialog} open={submitDialogOpen} />
    </div>
  )
}
